<template>
  <div id="footer-comp">
    <div class="footer-inner flex-wrapper">
      <div class="footer-block">
        <p class="footer-title">
          关于我们
        </p>
        <div class="footer-content">我们致力于创建中国最专业的投资者教育平台，打造中国一流的投资者教育基地培训中国最顶尖的师资力量，服务中国最前沿的金融市场。
        </div>
      </div>
      <div class="footer-block">
        <p class="footer-title">
          关注我们
        </p>
        <div class="footer-content">
          <p class="accounts-wrap">
            <a href="https://weibo.com/xhszgcfw" target="_blank">
              新浪微博
            </a>
            <a href="javascript:void(0)" class="qrcode-wrap">
              微信公众号
              <img src="../common/img/wx.png" alt="">
            </a>
            <a href="javascript:void(0)" class="qrcode-wrap">
              抖音
              <img src="../common/img/dy.png" alt="">
            </a>
            <a href="javascript:void(0)" class="qrcode-wrap">
              快手
              <img src="../common/img/ks.png" alt="">
            </a>
          </p>
          <div class="accounts-wrap app-icon-wrap">
            <a href="javascript:void(0)" class="qrcode-wrap img-wrap">
              <img src="../common/img/app.png" alt="">
            </a>
            <a href="javascript:void(0)" class="qrcode-wrap img-wrap">
              <img src="../common/img/app.png" alt="">
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'commonFooter',
  data(){
    return{
      
    }
  },
  mounted() {
    
  },
  methods:{
    
  }
}
</script>

<style lang="less">
@import '../common/global.less';
#footer-comp{
  background-color:#F5F5F5;
  border-top: 2px solid #376DD3;
  height:240px;
  width:100%;
  .footer-inner{
    width:1200px;
    margin:60px auto 0;
    justify-content: space-between;
    .footer-block{
      width:500px;
      .footer-title{
        font-size:18px;
        color:#333333;
        font-weight: bold;
        margin-bottom: 26px;
      }
      .footer-content{
        color:#333333;
        font-size:14px;
        line-height: 2em;
        .accounts-wrap{
          display: flex;
          a{
            margin-right: 35px;
            &.qrcode-wrap{
              position: relative;
              img{
                position: absolute;
                width: 145px;
                height: 152px;
                left:50%;
                margin-left:-72.5px;
                bottom:9px;
                display: none;
              }
              &:hover{
                opacity: 1;
                img{
                  display: block;
                }
              }
            }
            &.img-wrap{
              display: block;
              width:42px;
              height:42px;
              background: top center no-repeat;
              &:first-child{
                background-image:url(../common/img/ios.png);
              }
              &:last-child{
                background-image:url(../common/img/android.png);
              }
            }
          }
          &.app-icon-wrap{
            margin-top:20px;
            a{
              &.qrcode-wrap{
                img{
                  bottom:30px;
                }
                &:hover{
                  opacity: 0.9;
                  img{
                    display: block;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

</style>

